import React from "react";
import { get, toLower } from "lodash";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
} from "@mui/material";
import BrokerCommissions from "./BrokerCommissions";
import CommissionDistribution from "./CommissionDistribution";
import documentTypes from "../documents/documentTypes";
import { disabledStatuses } from "./constants";
import Installments from "../deal/Installments";
import "./VoucherForm.css";

const VoucherForm = (props) => {
    const {
        autocompleteResults,
        brokerCommissions,
        determineOutsidePresent,
        documentWarning,
        errors,
        handleAddArrayElement, //(path)
        handleAddBrokerCommission,
        handleAddRunner,
        handleCheckboxClick,
        handleConfirmWarning,
        handleCreateOutsideSplitDraft,
        handleDeleteOutsideSplit,
        handleDocumentWarning,
        handleInput,
        handleReducerLevelInput,
        handleRemoveCommissionOrRunner,
        handleSaveOutsideSplit,
        handleSearchBroker,
        handleSearchCompany,
        handleSearchPerson,
        handleUpdateArrayElement, //(arrayPath, index, field, value)
        handleVoucherChangeAndCalculateSplits,
        outsideSplitModal,
        outsideSplits,
        searchResults,
        toggleOutsideSplitModal,
        updateBrokerPerson,
        updateRunner,
        updateSplit,
        userProfile,
        voucher,
    } = props;

    const formDisabled = get(disabledStatuses, `${userProfile.role}.${voucher.voucherStatus}`, true);

    return (
        <React.Fragment>
            <form>
                <div className="simPaper">
                    <div className={"formTitleNoSpace"}> Voucher Information </div>
                    <small className="entityIDText">Deal ID: {voucher.deal.dealKey}</small>
                    <CommissionDistribution {...props} formDisabled={formDisabled} />

                    <Installments
                        {...props}
                        installments={get(voucher, "deal.installments", [])}
                        handleAddArrayElement={handleAddArrayElement}
                        handleUpdateArrayElement={(arrayPath, index, field, value) =>
                            handleUpdateArrayElement("deal." + arrayPath, index, field, value)
                        }
                        errors={errors}
                        disableInputs={formDisabled}
                        onlyEditCurrentAndFuture={true}
                        preventAddSubtract={true}
                        voucher={voucher}
                        handleVoucherChangeAndCalculateSplits={handleVoucherChangeAndCalculateSplits}
                        isVoucher={true}
                    />

                    <div className="voucherFormDisplayFlexUnresponsive">
                        <div className="kmExclusive">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={get(voucher, "deal.kmExclusiveFlg") ? true : false}
                                        onChange={(e) => handleCheckboxClick("deal.kmExclusiveFlg", e)}
                                        value={voucher.kmExclusiveFlg}
                                        color="primary"
                                        disabled={formDisabled}
                                    />
                                }
                                label="Is this listing KM Exclusive?"
                            />
                        </div>
                        <div>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={get(voucher, "deal.propertyManagementPaymentFlg") ? true : false}
                                        onChange={(e) => handleCheckboxClick("deal.propertyManagementPaymentFlg", e)}
                                        value={voucher.propertyManagementPaymentFlg}
                                        color="primary"
                                        disabled={formDisabled}
                                    />
                                }
                                label="Is this payment handled by Asset Services?"
                            />
                        </div>
                    </div>

                    <hr />

                    <BrokerCommissions
                        {...props}
                        voucher={voucher}
                        brokerCommissions={brokerCommissions}
                        outsideSplits={outsideSplits}
                        handleAddBrokerCommission={handleAddBrokerCommission}
                        handleCreateOutsideSplitDraft={handleCreateOutsideSplitDraft}
                        handleSaveOutsideSplit={handleSaveOutsideSplit}
                        handleDeleteOutsideSplit={handleDeleteOutsideSplit}
                        handleAddRunner={handleAddRunner}
                        handleRemoveCommissionOrRunner={handleRemoveCommissionOrRunner}
                        updateSplit={updateSplit}
                        updateRunner={updateRunner}
                        outsideSplitModal={outsideSplitModal}
                        toggleOutsideSplitModal={toggleOutsideSplitModal}
                        determineOutsidePresent={determineOutsidePresent}
                        handleSearchPerson={handleSearchPerson}
                        handleSearchCompany={handleSearchCompany}
                        searchResults={searchResults}
                        updateBrokerPerson={updateBrokerPerson}
                        errors={errors}
                        formDisabled={formDisabled}
                        autocompleteResults={autocompleteResults}
                        handleSearchBroker={handleSearchBroker}
                        handleInput={(path, value) => handleInput(path, value)}
                        handleReducerLevelInput={handleReducerLevelInput}
                    />
                </div>
            </form>
            <Dialog
                open={documentWarning.open}
                onClose={() => handleDocumentWarning(false, documentWarning.proceed, [])}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Are you sure you want to submit?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        You are responsible for ensuring this deal has the necessary legal documents. The following
                        documents are still required for this deal to be compliant:
                        <ul>
                            {documentWarning.docs.map((x, i) => (
                                <li>
                                    {get(
                                        documentTypes,
                                        `${toLower(get(voucher, "deal.transactionType", ""))}.${x}.display`,
                                        ""
                                    )}
                                </li>
                            ))}
                        </ul>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleDocumentWarning(false, false, [])} color="primary">
                        Add more docs
                    </Button>
                    <Button onClick={() => handleConfirmWarning(documentWarning.callback)} color="primary" autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default VoucherForm;
